import {STitle} from "shj-components";
import {FormOutlined} from "@ant-design/icons";
import styles from '@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less'
import AddNewPlanModal from "@/components/AddNewPlanModal";
import React, {useContext} from "react";
import {useSetState} from "ahooks";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import dayjs from "dayjs";
import classNames from "classnames";
import AddOrEditTrack from "@/pages/clueManage/clueDetail/components/Modals/AddOrEditTrack";
import {getAuth} from "@/utils/auth.ts";

const TrackInfo = ({detail = {}}) => {
  const {detailState, updateDetail} = useContext(ClueDetailContext)
  const auth = getAuth()
  const [state, setState] = useSetState<any>({
    open: false,
  })

  const onEditUserInfo = () => {
    setState({open: true})
  }

  return <div >
    <div className={classNames([styles.flexBetweenStart, styles.mb20])} style={{alignItems: 'center'}}>
      <STitle title={'商机信息'}/>
      {detailState.isPublicSea ? null : auth['trackInfoEdit'] && <FormOutlined onClick={onEditUserInfo}/>}
    </div>
    <div>
      {/*<p className={styles.mb20}>
        <span className={styles.label}>天猫订单号：</span>
        <span className={styles.value}>{detail?.aliOrderNumber}</span>
      </p>*/}
      <p className={styles.mb20}>
        <span className={styles.label}>商机ID：</span>
        <span className={styles.value}>{detail?.id}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>商机状态：</span>
        <span className={styles.value}>{detail?.statusDesc}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>需求标签：</span>
        <span className={styles.value}>{detail?.bizTypeName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>产品意向：</span>
        <span className={styles.value}>{detail?.intentionProductName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>签单意向：</span>
        <span className={styles.value}>{detail?.signIntentionName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>最近预约见面时间：</span>
        <span className={styles.value}>{detail?.lastAppointmentTime ? dayjs(detail.lastAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>最近见面时间：</span>
        <span className={styles.value}>{detail?.lastArriveTime ? dayjs(detail.lastArriveTime).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>预计签单时间：</span>
        <span className={styles.value}>{detail?.expectSignTime && dayjs(detail?.expectSignTime).format('YYYY-MM-DD')}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>预计签单金额：</span>
        <span className={styles.value}>{detail?.expectSignAmount}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>预计进场装修时间：</span>
        <span className={styles.value}>{detail?.expectRenovationDate && dayjs(detail?.expectRenovationDate).format('YYYY-MM-DD')}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>痛点：</span>
        <span className={styles.value}>{detail?.painPointName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>痛点备注：</span>
        <span className={styles.value}>{detail?.painPointRemark || '-'}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>痒点：</span>
        <span className={styles.value}>{detail?.itchPointName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>痒点备注：</span>
        <span className={styles.value}>{detail?.itchPointRemark || '-'}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>障碍点：</span>
        <span className={styles.value}>{detail?.blockPointName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>障碍点备注：</span>
        <span className={styles.value}>{detail?.blockPointRemark || '-'}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>爆破点：</span>
        <span className={styles.value}>{detail?.breakPointName}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>爆破点备注：</span>
        <span className={styles.value}>{detail?.breakPointRemark || '-'}</span>
      </p>
      <p className={styles.mb20}>
        <span className={styles.label}>备注：</span>
        <span className={styles.value}>{detail?.remark}</span>
      </p>
    </div>
    { state.open && <AddOrEditTrack basicInfo={detail}
                                     editReload={() => {}}
                                     reload={() => updateDetail({isReloadTrack: !detailState.isReloadTrack})}
                                     isEdit={true}
                                     open={state.open}
                                     onClose={() => setState({open: false})} /> }

  </div>
}

export default TrackInfo